import React from 'react';
import PropTypes from 'prop-types';
import FormGroup from '@material-ui/core/FormGroup';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Checkbox from '@material-ui/core/Checkbox';

export default function SplatnostForm(props) {
  const {
    onChecked,
    year5,
    year10,
    year15,
    year20,
    year25,
    fondOprav,
    mesicniSplatky,
  } = props;

  return (
    <React.Fragment>
      <p>Požadovaná splatnost úvěru:</p>
      <FormGroup style={{ flexDirection: 'row', justifyContent: 'space-around' }}>
        <FormControlLabel
          control={(
            <Checkbox
              checked={year5}
              onChange={onChecked('year5')}
              value='5'
            />
          )}
          label='5 let'
        />
        <FormControlLabel
          control={(
            <Checkbox
              checked={year10}
              onChange={onChecked('year10')}
              value='10'
            />
          )}
          label='10 let'
        />
        <FormControlLabel
          control={(
            <Checkbox
              checked={year15}
              onChange={onChecked('year15')}
              value='15'
            />
          )}
          label='15 let'
        />
        <FormControlLabel
          control={(
            <Checkbox
              checked={year20}
              onChange={onChecked('year20')}
              value='20'
            />
          )}
          label='20 let'
        />
        <FormControlLabel
          control={(
            <Checkbox
              checked={year25}
              onChange={onChecked('year25')}
              value='25'
            />
          )}
          label='25 let'
        />
        <FormControlLabel
          control={(
            <Checkbox
              checked={fondOprav}
              onChange={onChecked('fondOprav')}
              value='fondOprav'
            />
          )}
          label='Nastavit dle možností fondu oprav'
        />
        <FormControlLabel
          control={(
            <Checkbox
              checked={mesicniSplatky}
              onChange={onChecked('mesicniSplatky')}
              value='mesicniSplatky'
            />
          )}
          label='Nastavit dle maximální měsíční splátky'
        />
      </FormGroup>
    </React.Fragment>
  );
}

SplatnostForm.propTypes = {
  fondOprav: PropTypes.bool.isRequired,
  mesicniSplatky: PropTypes.bool.isRequired,
  onChecked: PropTypes.func.isRequired,
  year10: PropTypes.bool.isRequired,
  year15: PropTypes.bool.isRequired,
  year20: PropTypes.bool.isRequired,
  year25: PropTypes.bool.isRequired,
  year5: PropTypes.bool.isRequired,
};
